import { useState } from 'react';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import FormHelperText from '@mui/material/FormHelperText';
import { VisibilityIcon, VisibilityOffIcon } from './SvgIcon';


const labelSx = {
    position: 'relative',
    transform: 'none',
    mb: 0.5,
    fontSize: '0.875rem',
    fontWeight: 500,
    color: 'text.primary',
    '&.Mui-focused': {
        color: 'text.primary',
    },
    '&.Mui-disabled': {
        color: 'text.primary',
    },
};

const PasswordInput = ({
    id,
    value,
    onChange,
    onBlur,
    onKeyDown,
    placeholder,
    label = 'Password',
    autoComplete = 'off',
    autoFocus = false,
    disabled = false,
    name,
    inputRef,
    error = false,
    helperText,
    fullWidth = true,
    size = 'small',
    required = false,
    dataAutomationId,
}) => {
    const [showPassword, setShowPassword] = useState(false);

    const handleToggle = () => {
        setShowPassword(prev => !prev);
    };

    const handleMouseDown = (event) => {
        event.preventDefault();
    };

    const helperId = id ? `${id}-helper` : undefined;

    return (
        <FormControl variant="outlined" fullWidth={fullWidth} size={size} error={error} disabled={disabled}>
            {label && (
                <InputLabel shrink htmlFor={id} required={required} sx={labelSx}>
                    {label}
                </InputLabel>
            )}
            <OutlinedInput
                id={id}
                name={name}
                type={showPassword ? 'text' : 'password'}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                onKeyDown={onKeyDown}
                placeholder={placeholder}
                autoComplete={autoComplete}
                autoFocus={autoFocus}
                disabled={disabled}
                inputRef={inputRef}
                notched={false}
                // Edge/IE render their own eye button on input[type=password]; hide it so only
                // the custom toggle below shows.
                sx={{ '& input::-ms-reveal, & input::-ms-clear': { display: 'none' } }}
                aria-invalid={error || undefined}
                aria-describedby={(helperText && helperId) || undefined}
                inputProps={{
                    ...(required ? { 'aria-required': true } : {}),
                    ...((dataAutomationId || id) ? { 'data-automation-id': dataAutomationId || id } : {}),
                }}
                endAdornment={
                    <InputAdornment position="end">
                        <IconButton
                            aria-label={showPassword ? 'Hide password' : 'Show password'}
                            aria-pressed={showPassword}
                            onClick={handleToggle}
                            onMouseDown={handleMouseDown}
                            edge="end"
                            size="small"
                            data-automation-id={(dataAutomationId || id) ? `${dataAutomationId || id}_visibility_btn` : undefined}
                        >
                            {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                        </IconButton>
                    </InputAdornment>
                }
            />
            <FormHelperText id={helperId} sx={{ my: 0 }}>{helperText || ' '}</FormHelperText>
        </FormControl>
    );
};

export default PasswordInput;
